/* Hype pages — hero video.
   The headline stack stays hidden until the visitor first tries to scroll.
   On that first gesture the page is held in place, the copy animates in, and
   scrolling is handed back. Below 900px the animation just runs on load. */

(function () {
  function initSection(section) {
    if (section.dataset.hypeHeroReady === "true") return;
    section.dataset.hypeHeroReady = "true";

    var container = section.querySelector(".video-container");
    var cta = section.querySelector(".hype-cta");

    window.HypeCore.ready(function (core) {
      var animationTriggered = false;
      var isAnimating = false;

      gsap.set(container, { backgroundColor: "transparent" });
      gsap.set(container.querySelectorAll(".hype-h3, .hype-h1, .hype-cta"), {
        opacity: 0,
        y: 50
      });

      var tl = gsap.timeline({
        paused: true,
        onComplete: function () {
          isAnimating = false;
          if (core.smoother) core.smoother.paused(false);
        }
      });

      tl.to(container, { backgroundColor: "#00000033", duration: 0.3, ease: "power2.inOut" })
        .to(container.querySelector(".hype-h3"), { opacity: 1, y: 0, duration: 0.3 })
        .to(container.querySelector(".hype-h1"), { opacity: 1, y: 0, duration: 0.3 }, "+=0.3");

      if (cta) {
        tl.to(cta, { opacity: 1, y: 0, duration: 0.3 }, "+=0.3").to(
          cta,
          {
            backgroundPosition: "calc(-28%) center",
            color: "#fff",
            duration: 0.3,
            ease: "power1.inOut"
          },
          "+=0.2"
        );
      }

      if (window.matchMedia("(min-width: 901px)").matches) {
        var scrollStartPosition = 0;
        var hasScrolled = false;

        var handleScroll = function (event) {
          if (!hasScrolled) {
            hasScrolled = true;
            scrollStartPosition = window.scrollY || document.documentElement.scrollTop;
            if (event.type === "wheel") event.preventDefault();
          }

          if (animationTriggered || isAnimating) return;

          var current = window.scrollY || document.documentElement.scrollTop;
          if (Math.abs(current - scrollStartPosition) > 5) {
            animationTriggered = true;
            isAnimating = true;
            if (core.smoother) core.smoother.paused(true);
            tl.play();
            window.scrollTo(0, scrollStartPosition);
          }
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("wheel", handleScroll, { passive: false });
        window.addEventListener(
          "wheel",
          function (event) {
            if (isAnimating) {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
          },
          { passive: false }
        );
      } else {
        animationTriggered = true;
        tl.play();
      }

      if (!cta) return;

      cta.addEventListener("mouseenter", function () {
        cta.style.backgroundPosition = animationTriggered ? "calc(28%) center" : "calc(-28%) center";
        cta.style.color = animationTriggered ? "inherit" : "#fff";
      });

      cta.addEventListener("mouseleave", function () {
        cta.style.backgroundPosition = animationTriggered ? "calc(-28%) center" : "calc(28%) center";
        cta.style.color = animationTriggered ? "#fff" : "inherit";
      });
    });
  }

  function init() {
    if (!window.HypeCore || typeof gsap === "undefined") return;
    document.querySelectorAll(".hype-video-section").forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
